import ScrollToTopButton from "../../components/ScrollToTopButton";
import { Banner, BlueCard } from "../../images/index";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "./form";
import { useEffect, useState, useRef } from "react";
import JobDescription from "./jobDescription";

function Hire() {
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [showForm, setShowForm] = useState(true);
  const { job } = location.state || {};

  const handleClick = () => {
    navigate("/contact");
  };

  useEffect(() => {
    if (!job) {
      navigate("/Careers");
    }
  }, [job, navigate]);

  const handleApplyClick = () => {
    setShowForm((prev) => !prev);
  };

  useEffect(() => {
    if (!showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showForm]);
  return (
    <div>
      <div className="relative min-h-[500px]">
        <img
          src={Banner}
          alt="About Banner"
          className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
        />

        <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
          <div className="w-full justify-center grid text-center max-w-5xl mx-auto space-y-3 font-roboto mt-24">
            <span className="flex items-center font-bold text-lg tracking-wider space-x-2 justify-center mt-10">
              <span className="w-[21px] h-[6px] bg-activeColor"></span>
              <span className="w-[36px] h-[6px] bg-activeColor"></span>
              <span className="text-[#475569]">RECRUITMENT</span>
            </span>
            <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
              {job?.title}
            </h1>
            <p className="text-lg text-[#404040] font-bold">
              {job?.location} | Posted On{" "}
              {new Date(job?.createdAt).toLocaleDateString()} | {job?.jobType} |{" "}
              {job?.experienceRequired} years experience
            </p>
            <div className="flex justify-center space-x-5">
              <button
                type="submit"
                className="bg-activeColor mt-4 text-white text-lg md:text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                I’m Interested
              </button>
              <button
                type="submit"
                className="text-[#F32F39] mt-4 border-2 border-[#F32F39] text-lg md:text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium transition-all flex items-center gap-4"
              >
                Share job via email
              </button>
            </div>
          </div>
        </div>
      </div>

      <section
        className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto py-12 px-6 md:px-0 font-roboto"
        ref={formRef}
      >
        <div className="text-lg font-600 mb-6">
          <span className={showForm ? "text-[#F42F39]" : "text-[#404040]"}>
            Job Listing
          </span>{" "}
          &nbsp;≪&nbsp;
          <span
            className={showForm ? "text-[#404040]" : "text-[#F42F39]"}
            onClick={handleApplyClick}
          >
            Job Details
          </span>
          {!showForm && (
            <>
              &nbsp;≪&nbsp;
              <span className="text-[#404040]" s>
                Job Application
              </span>
            </>
          )}
        </div>

        <div className="grid md:grid-cols-3 gap-10 border-t pt-6">
          {showForm && (
            <>
              <div className="md:col-span-2 space-y-10 border-r pr-8">
                <div>
                  <h2 className="text-3xl font-extrabold text-[#434253] mb-4">
                    About Us
                  </h2>
                  <p className="text-[#5F6870] text-xl font-500 leading-relaxed">
                    TechProjects is a global technology and innovation company
                    delivering AI-driven, cloud-enabled, and automation-led
                    digital transformation to leading enterprises across
                    industries.
                  </p>
                  <p className="text-[#5F6870] text-xl font-500 mt-4 leading-relaxed">
                    Founded in 2007 and headquartered in North Brunswick, NJ,
                    with Global Capability Centers (GCCs) in India, we help
                    clients transform operations through AI, data engineering,
                    intelligent automation, cybersecurity, and digital
                    platforms.
                  </p>
                  <p className="text-[#5F6870] text-xl font-500 mt-4 leading-relaxed">
                    Our U.S.–India hybrid delivery model ensures seamless
                    collaboration, speed, and innovation, while our culture
                    fosters creativity, agility, and integrity in every
                    engagement.
                  </p>
                  <span className="flex items-center tracking-wider space-x-2 mt-8">
                    <span className="w-[6px] h-[24px] bg-[#5F6870]"></span>
                    <span className="text-[#5F6870] text-lg font-300 leading-relaxed italic">
                      We’re not just building projects — we’re building
                      innovation platforms for the future.
                    </span>
                  </span>
                </div>
                {/* Job Description from the backend response */}
                <JobDescription html={job?.jobDescription} />
                <div>
                  <h2 className="text-3xl font-extrabold text-[#434253] mb-4">
                    Life at TechProjects
                  </h2>
                  <p className="text-[#5F6870] text-xl font-500 mt-4 leading-relaxed">
                    At TechProjects, we foster a growth-oriented and
                    collaborative culture where innovation is encouraged, and
                    every voice is valued.
                  </p>
                  <p className="text-[#5F6870] text-xl font-500 mt-4 leading-relaxed">
                    Our team members describe us as a place where “you learn
                    fast, innovate freely, and make a lasting impact.”
                  </p>
                </div>
                <div>
                  <h2 className="text-3xl font-extrabold text-[#434253] mb-4">
                    We Offer
                  </h2>
                  <ul className="list-disc ml-10 text-[#475569] text-xl leading-relaxed space-y-3">
                    <li>Flexible hybrid work models</li>
                    <li>Transparent leadership and mentorship</li>
                    <li>
                      Opportunities to work on global AI and automation projects
                    </li>
                    <li>
                      A culture that celebrates creativity, ownership, and
                      excellence
                    </li>
                  </ul>
                </div>
                <span className="flex items-center tracking-wider space-x-2 mt-8">
                  <span className="w-[6px] h-[24px] bg-[#5F6870]"></span>
                  <span className="text-[#5F6870] text-lg font-300 leading-relaxed italic">
                    Join a team where ideas turn into innovation and innovation
                    drives real-world change.
                  </span>
                </span>
                <div className="pt-6">
                  <h2 className="text-3xl font-extrabold text-[#434253] mb-4">
                    Ready to Apply?
                  </h2>
                  <p className="text-[#5F6870] font-500 text-xl leading-relaxed mb-6">
                    If you’re passionate about driving AI, Automation, and Cloud
                    transformation — and ready to lead global projects that make
                    an impact — we’d love to hear from you.
                  </p>
                  <button
                    onClick={handleApplyClick}
                    className="bg-[#ef4444] hover:bg-red-600 text-white font-semibold px-6 py-3 rounded-md shadow transition"
                  >
                    Apply Now
                  </button>
                </div>
              </div>

              <aside className="h-fit">
                <h3 className="text-3xl font-extrabold text-[#434253] mb-4">
                  Job Information
                </h3>
                <ul className="space-y-4">
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Department Name
                    </strong>
                    <br />
                    {job?.department || "AI & Digital Transformation"}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Job Type
                    </strong>
                    <br />
                    {job?.jobType || "Full Time"}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Work Experience
                    </strong>
                    <br />
                    {`${job?.experienceRequired} years` || "5+ years"}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Date Opened
                    </strong>
                    <br />
                    {new Date(job?.dateOpened).toLocaleDateString()}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Status
                    </strong>
                    <br />
                    {job?.status}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Industry
                    </strong>
                    <br />
                    {job?.industry}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Salary
                    </strong>
                    <br />
                    {job?.salaryRange}
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      City
                    </strong>
                    <br />
                    {job?.city}
                  </li>
                  {/* <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold tex-lg">
                      Country
                    </strong>
                    <br />
                    India
                  </li>
                  <li className="text-[#475569] font-400 text-lg">
                    <strong className="text-[#0F172A] font-semibold text-lg">
                      Postal Code
                    </strong>
                    <br />
                    500081
                  </li> */}
                </ul>
              </aside>
            </>
          )}
        </div>

        {!showForm && (
          <section>
            {" "}
            <Form />{" "}
          </section>
        )}

        <div className="flex justify-center space-x-6 items-center mt-10 text-lg text-[#F32F39] font-semibold">
          <button className="hover:underline">View All Jobs</button>
          <button
            className="hover:underline"
            onClick={() => navigate("/Careers")}
          >
            Back To Website
          </button>
        </div>
      </section>

      <div
        className="w-full bg-cover bg-no-repeat p-[5rem]"
        style={{ backgroundImage: `url(${BlueCard})` }}
      >
        <div className="grid items-center justify-center h-full max-w-6.5xl mx-auto left-0 right-0 px-4 md:px-6">
          <div className="font-roboto text-4xl md:text-6xl text-center text-white font-medium max-w-5xl grid space-y-6">
            <span>Ready to Create Impact in Your Business?</span>
          </div>

          <div className="w-full md:max-w-6xl mx-auto gap-6 flex md:justify-center justify-center mt-10">
            <button
              type="submit"
              className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
            >
              Start Your Project
            </button>
            <button
              onClick={handleClick}
              type="submit"
              className=" text-white border-white border text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium transition-all flex items-center gap-4"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      <ScrollToTopButton />
    </div>
  );
}

export default Hire;
